import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { candidateAPI, interviewAPI } from '../../services/api';
import ResumeUpload from '../common/ResumeUpload';
import './Dashboard.css';

const CandidateDashboard = () => {
  const navigate = useNavigate();
  const [interviews, setInterviews] = useState([]);
  const [resume, setResume] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [interviewsRes, resumeRes] = await Promise.all([
        candidateAPI.getInterviews(),
        candidateAPI.getResume().catch(() => null)
      ]);
      
      setInterviews(interviewsRes.data || []);
      setResume(resumeRes?.data || null);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStartInterview = async (interviewId) => {
    try {
      await interviewAPI.startInterview(interviewId);
      navigate(`/interview/${interviewId}`);
    } catch (error) {
      alert('Error starting interview: ' + (error.response?.data?.detail || error.message));
    }
  };

  if (loading) {
    return <div className="dashboard loading">Loading...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Candidate Dashboard</h1>
        <button 
          className="btn btn-secondary"
          onClick={() => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            navigate('/login');
          }}
        >
          Logout
        </button>
      </div>

      <div className="dashboard-content">
        <div className="section">
          <h2>Resume</h2>
          {resume ? (
            <div className="resume-info">
              <p>Resume uploaded: {resume.original_filename}</p>
              {resume.parsed_data && (
                <div className="resume-details">
                  <h3>Skills:</h3>
                  <ul>
                    {resume.parsed_data.skills?.map((skill, i) => (
                      <li key={i}>{skill}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ) : (
            <ResumeUpload onUploadSuccess={loadData} />
          )}
        </div>

        <div className="section">
          <h2>Interviews</h2>
          {interviews.length === 0 ? (
            <p>No interviews scheduled</p>
          ) : (
            <div className="interviews-list">
              {interviews.map((interview) => (
                <div key={interview.id} className="interview-card">
                  <div className="interview-info">
                    <h3>Interview #{interview.id.slice(0, 8)}</h3>
                    <p>Status: <span className={`status ${interview.status}`}>{interview.status}</span></p>
                    {interview.started_at && (
                      <p>Started: {new Date(interview.started_at).toLocaleString()}</p>
                    )}
                  </div>
                  <div className="interview-actions">
                    {interview.status === 'scheduled' && (
                      <button
                        className="btn btn-primary"
                        onClick={() => handleStartInterview(interview.id)}
                      >
                        Start Interview
                      </button>
                    )}
                    {interview.status === 'completed' && (
                      <button
                        className="btn btn-secondary"
                        onClick={() => navigate(`/dashboard/interview/${interview.id}/report`)}
                      >
                        View Report
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CandidateDashboard;

